export default __webpack_public_path__ + "static/media/background.3a6a931d.jpg";